import React from 'react';
import fr from '../locales/fr';
import en from '../locales/en';
import de from '../locales/de';
import es from '../locales/es';
import it from '../locales/it';

export const DICTS = { fr, en, de, es, it };
export const LANGS = [
  { code: 'fr', label: 'Français', flag: 'fr' },
  { code: 'en', label: 'English', flag: 'gb' },
  { code: 'de', label: 'Deutsch', flag: 'de' },
  { code: 'es', label: 'Español', flag: 'es' },
  { code: 'it', label: 'Italiano', flag: 'it' },
];
const KEY = 'uiLang';
const SUGGEST_KEY = 'uiLangSuggestDismissed';
const EVENT = 'lang-changed';
const SUPPORTED = Object.keys(DICTS);

const detect = () => {
  const fromUrl = new URLSearchParams(window.location.search).get('lang');
  if (SUPPORTED.includes(fromUrl)) { localStorage.setItem(KEY, fromUrl); return fromUrl; }
  const saved = localStorage.getItem(KEY);
  return SUPPORTED.includes(saved) ? saved : 'fr';
};

// Browser language worth suggesting to a first-time visitor (never saved a choice yet)
export const suggestedLang = () => {
  if (localStorage.getItem(KEY) || localStorage.getItem(SUGGEST_KEY)) return null;
  const nav = (navigator.language || '').slice(0, 2).toLowerCase();
  return SUPPORTED.includes(nav) && nav !== 'fr' ? nav : null;
};
export const dismissSuggestion = () => localStorage.setItem(SUGGEST_KEY, '1');

let current = detect();
document.documentElement.lang = current;

const interpolate = (str, vars) => str.replace(/\{(\w+)\}/g, (m, k) => (vars && vars[k] !== undefined ? vars[k] : m));

export const translate = (lang, key, vars) => {
  let value = DICTS[lang]?.[key] ?? DICTS.fr[key];
  if (value === undefined) return key;
  if (typeof value === 'object') value = (vars?.count === 1 ? value.one : value.other) ?? value.other;
  return interpolate(value, vars);
};

export const i18n = {
  get: () => current,
  set: (lang) => {
    if (!SUPPORTED.includes(lang) || lang === current) return;
    current = lang;
    localStorage.setItem(KEY, lang);
    document.documentElement.lang = lang;
    window.dispatchEvent(new Event(EVENT));
  },
  subscribe: (cb) => {
    window.addEventListener(EVENT, cb);
    return () => window.removeEventListener(EVENT, cb);
  },
  t: (key, vars) => translate(current, key, vars),
  locale: () => ({ fr: 'fr-FR', en: 'en-GB', de: 'de-DE', es: 'es-ES', it: 'it-IT' }[current]),
  formatDateTime: (iso) => {
    const d = new Date(iso);
    return Number.isNaN(d.getTime()) ? '' : d.toLocaleString(i18n.locale(), { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  },
};

export const useT = () => {
  const [lang, setLang] = React.useState(i18n.get);
  React.useEffect(() => i18n.subscribe(() => setLang(i18n.get())), []);
  const t = React.useCallback((key, vars) => translate(lang, key, vars), [lang]);
  return { t, lang };
};
